import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["data-test-id"]
const _hoisted_2 = {
  key: 0,
  class: "font-sans font-medium text-racq-dark-grey"
}
const _hoisted_3 = { class: "w-full overflow-x-scroll no-scrollbar py-3 last:pb-0" }
const _hoisted_4 = {
  key: 0,
  class: "w-[16px]"
}
const _hoisted_5 = {
  key: 1,
  class: "w-[16px]"
}

import { Item, Field, ComponentRendering } from '@sitecore-jss/sitecore-jss/types/layout';
import { Image, Link } from '@sitecore-jss/sitecore-jss-vue';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';
import { LinkField } from '@sitecore-jss/sitecore-jss-vue/types/components/Link';
import { usePageStore } from '@/store';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionBar',
  props: {
    title: { default: undefined },
    innerClass: { default: undefined },
    outerClass: { default: undefined },
    fields: {},
    rendering: { default: undefined },
    handleLinkClickEvent: { type: Boolean, default: false }
  },
  emits: ['btnClick'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const dataTestId = usePageStore().dataTestId(props.rendering);

const getIconPosition = (item: Item) => ((item.fields?.iconPosition ?? item.iconPosition) as Field<string>)?.value;

const emit = __emit;

const onClick = (linkItem: any) => {
  if (!props.handleLinkClickEvent) return;
  emit('btnClick', linkItem);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { "data-test-id": _unref(dataTestId) }, [
    (!!(_ctx.fields?.title?.value ?? _ctx.title?.value))
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.fields?.title?.value ?? _ctx.title?.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.fields?.outerClass?.value ?? _ctx.outerClass?.value)
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", {
          class: _normalizeClass(["py-2 flex flex-nowrap md:flex-wrap gap-x-3 gap-y-4 pl-4 md:pl-0", _ctx.fields?.innerClass?.value ?? _ctx.innerClass?.value])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields.childItems ?? _ctx.fields, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "p-0 m-0"
            }, [
              _createVNode(_unref(Link), {
                href: _ctx.handleLinkClickEvent ? 'javascript:void(0)' : (item?.link?.value?.href ?? item?.value?.link?.href),
                "data-test-id": (item.fields?.dataTestId ?? item?.dataTestId)?.value,
                field: item.fields?.link ?? item?.link,
                class: _normalizeClass({
                'flex flex-nowrap items-center gap-[6px] px-6 py-[7px] no-underline active:no-underline whitespace-nowrap !rounded-3xl bg-true-white hover:bg-racq-pale-blue active:bg-racq-white !border-[1.5px] border-racq-light-blue-grey hover:border-racq-blue-border active:border-racq-blue-active text-racq-med-grey text-base-bold active:text-racq-navy': true,
                'pl-4': getIconPosition(item) === 'left',
                'pr-4': getIconPosition(item) === 'right',
                disabled: (item.fields?.disabled?.value ?? item.disabled?.value) === '1',
              }),
                onClick: ($event: any) => (onClick(item))
              }, {
                default: _withCtx(() => [
                  (getIconPosition(item) === 'left')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_unref(Image), {
                          media: ((item.fields?.icon ?? item?.icon) as Field<ImageFieldValue>)?.value,
                          class: "w-[16px]",
                          width: "16",
                          height: "16"
                        }, null, 8, ["media"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, _toDisplayString(item.fields?.link?.value?.text ?? item.link?.value?.text), 1),
                  (getIconPosition(item) === 'right')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_unref(Image), {
                          media: ((item.fields?.icon ?? item.icon) as LinkField)?.value,
                          class: "w-[16px]",
                          width: "16",
                          height: "16"
                        }, null, 8, ["media"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["href", "data-test-id", "field", "class", "onClick"])
            ]))
          }), 128)),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-4 md:hidden flex-shrink-0" }, null, -1))
        ], 2)
      ])
    ], 2)
  ], 8, _hoisted_1))
}
}

})